var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1568 6.07715L15.227 4.62402L2.02597 13.162L0 19.1571L6.87867 22.0798L21.1213 12.7095L19.1568 6.07715Z",
    fill: "#E9A825"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1566 6.07721L5.89404 14.7985L6.87848 22.0798L21.1211 12.7095L19.1566 6.07721Z",
    fill: "#FFCE54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8944 14.7984L2.02613 13.162L0.000976562 19.1571L6.87883 22.0798L5.8944 14.7984Z",
    fill: "#BC8628"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0357 8.99937L22.1059 7.54559L8.90488 16.0841L6.87891 22.0799L13.7575 25L28.0001 15.6304L26.0357 8.99937Z",
    fill: "#E9A825"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0355 8.99927L12.7729 17.7186L13.7573 24.9999L28 15.6303L26.0355 8.99927Z",
    fill: "#FFCE54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7731 17.7186L8.90488 16.0841L6.87891 22.0798L13.7575 25L12.7731 17.7186Z",
    fill: "#BC8628"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6784 1.45305L17.7494 0L5.68146 7.84642L3.65625 13.8415L10.5349 16.763L23.6437 8.08465L21.6784 1.45305Z",
    fill: "#E9A825"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6786 1.453L9.55078 9.4815L10.5352 16.7629L23.6439 8.08461L21.6786 1.453Z",
    fill: "#FFCE54"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55055 9.48156L5.68146 7.84644L3.65625 13.8415L10.5349 16.763L9.55055 9.48156Z",
    fill: "#BC8628"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.ea5269678e97593b78a2dbcc6fc7f727.svg";
export { ForwardRef as ReactComponent };